// SPDX-FileCopyrightText: 2024 LiveKit, Inc.
//
// SPDX-License-Identifier: Apache-2.0
export const STREAM_CHUNK_SIZE_BYTES = 15_000;

export const DEFAULT_MAX_PAYLOAD_BYTE_LENGTH = 5_000_000_000;
